// In the past we used Segment Analytics for tracking events. With the death of CFT, it really
// didn't make sense to keep that subscription alive so killing it. Also, there really wasn't anyone
// looking at the data, so...until that changes, leaving the implementation in place so that 
// where tracking calls were made will remain.  At this point, it makes more sense just to use
// a SQL implementation with Power BI for the visualization platform.

export enum EventCategory {
    Import = 'Import',
    User = 'User',
    Workspace = 'Workspace',
}

export const MetricsService = {

    // identify the current user
    // 
    // For the portal, user should be the tenant and id should be the id of the borrower 
    // (entityId to which imported data would be linked under.) 

    identifyUser(user: string, id: string) {
    },

    /**
     *  This method allows for an arbitrary JSON value to be passed in as value.  
     *  
     *  For Segment, the entirety of that value will be available in Segment.
     */

    tryTrackEvent(
        category: EventCategory,
        name: string,
        value?: any
    ) {
    },
};
